import { render, staticRenderFns } from "./CheckboxCell.vue?vue&type=template&id=f59fc156&scoped=true&"
import script from "./CheckboxCell.vue?vue&type=script&lang=js&"
export * from "./CheckboxCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f59fc156",
  null
  
)

export default component.exports